import { Button } from '@shipt/design-system-buttons'
import { ChevronDownIcon } from '@shipt/design-system-icons'
import { screenSizes } from '@shipt/design-system-themes'
import styled from 'styled-components'
import { DynamicCategoriesDrawer } from '@/features/shop/components/UngatedCategoryPage/CategoriesDrawer/DynamicCategoriesDrawer'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'

export const CategoriesDrawerOption = () => {
  const { openDialog } = useHandleDialog()
  return (
    <CategoriesOption
      variant="tertiary"
      size="sm"
      trailingIcon={ChevronDownIcon}
      onClick={() => {
        openDialog(DynamicCategoriesDrawer)
      }}
    >
      Categories
    </CategoriesOption>
  )
}

const CategoriesOption = styled(Button)`
  flex-shrink: 0;
  margin-right: 0.5rem;
  height: 1.75rem;
  white-space: nowrap;
  place-self: flex-end;

  @media ${screenSizes.tablet} {
    display: none;
  }
`
